module.exports = __webpack_public_path__ + "img/partly-cloudy.e2b38a98.png";